import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Card } from './ui/card';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is decimal?',
      answer:
        'Decimal is a beauty and skincare marketplace that delivers your favourite products within minutes. We also curate products specifically to your skin\'s needs using science, data, and dermatology-backed formulations.',
    },
    {
      question: 'How do I use decimal?',
      answer:
        'Simply download the decimal app from Google Play or App Store, create an account and buy your favourite beauty and skincare products directly or take a skin analysis for curated product recommendations. It\'s that easy!',
    },
    {
      question: 'How does personalization work?',
      answer:
        'You take a short skin quiz that analyzes: Skin type, Concerns (acne, pigmentation, aging, dryness, etc.), Lifestyle & environment, and Sensitivity level. Our system then recommends products best suited for your skin.',
    },
    {
      question: 'Is my data safe?',
      answer:
        'Yes. Your skin data is encrypted and never shared without your consent.',
    },
    {
      question: 'Where can I use decimal?',
      answer:
        'Decimal is currently available in Indiranagar, Bengaluru. We are rapidly expanding to more areas within Bengaluru and other cities across India.',
    },
    {
      question: 'How do I contact support?',
      answer:
        'You can reach our customer support team through the app chat, email at care@decimalskincare.com, or call our helpline at +919886606636. Our support team is available 24/7 to assist you with any queries or concerns.',
    },
  ];

  return (
    <section id="faqs" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-brand-100 px-4 py-2 rounded-full mb-4">
            <div className="w-2 h-2 bg-brand-600 rounded-full"></div>
            <span className="text-brand-700 font-medium">FAQ's</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Card
              key={index}
              className="border border-gray-200 hover:border-brand-300 transition-colors overflow-hidden"
            >
              <button
                className="w-full text-left px-6 py-4 flex justify-between items-center font-semibold text-gray-900 hover:text-brand-600 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span>{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-gray-600 animate-fade-in">
                  {faq.answer}
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;